module.exports = __webpack_public_path__ + "img/30ecec5.png";